<div class="bg-subscription-pay" style="width: 100%;">
  <header class="schoolm-header" style="width: 100%;">
    <div class="schoolm-header-content">
      <div class="logo">
        <img src="brand/logo.jpeg" alt="SchoolMatik Solutions" class="logo-min-image">
      </div>
       <h5 class="text-center fw-bold">Paiements scolarité par anticipation</h5>
    </div>
  </header>
  <div class="step-container">
    <div class="card-pay">
      <div  class="modal" tabindex="-1" role="dialog" id="modErrPay" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body"><span class="text-danger text-center font-weight-bold">{{message}}</span></div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
      @if (isBill) {
        <div id="bill-page" class="payment-page mt-3">
          <form [formGroup]="formBill">
            <div class="row justify-content-center">
              <img src="images/schoolmatik.jpeg" class="img-fluid col-2 mb-3">
             <p class="text-center fw-bold">Payez la scolarité de vos enfants avant l'heure</p>
            </div>
              <div class="form-group form-floating">
                <select formControlName="school" name="school" class="ml-2 mr-2 mt-2 form-select">
                  <option value="" selected>Choisir un établissement</option>
                  @for (school of schools; track school) {
                    <option value="{{school.id}}">{{school.name}}</option>
                  }
                </select>
                <label>Choisir un établissement</label>
              </div>
            
           
            <div class="form-group form-floating">
              <input type="text"  class="ml-2 mr-2 mt-2 form-control" placeholder="Entrer le code l'élève" formControlName="idStudent" id="idStudent">
              <label  for="idStudent">Entrer le code compta de l'élève</label>
            </div>
            <div class="d-grid gap-2 col-6 mx-auto mt-2">
              <button class="btn btn-success" (click)="findStudent()" [disabled]="!formBill.valid">Chercher</button>
            </div>
          </form>
        </div>
      }
      @if (isPayment) {
        <div>
          <div id="payment-page" class="payment-page">
            <h5 class="text-center fw-bold">Paiements scolarité</h5>
            <h6 class="text-center fw-bold"> Paiement anticipé</h6>
            <form [formGroup]="formPayment">
                <input type="hidden" formControlName="school">
                <input type="hidden" formControlName="idStudent">
            @if(student){
              
            <div class="mb-3">
              <label for="merchantName" class="form-label">Nom établissement: <span class="fw-bold">{{selectedSchool?.name}}</span></label>
            </div>
            <div class="mb-3">
              <label for="studentName" class="form-label">Nom de l'élève: <span class="fw-bold">{{student.studentName}}</span></label>
            </div>
            <div class="mb-3">
              <label for="echeance" class="form-label">Veuille selectionner les échéances concernées</label>
              <div class="row" formArrayName="echeances">
                @for (mois of listMois; track mois;let i=$index) {
                  <div class="col-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox"  id="mois-{{i}}" [formControlName]="i" >
                    <label class="form-check-label" for="mois-{{i}}">{{mois}}</label>
                   </div>
                   </div>
                  }
           
            </div>
            </div>
            <div class="form-floating mb-3">
               <input class="form-control" formControlName="amount" type="number" id="amount" (input)="getAmount()" min="{{mminAmount}}">
               <label for="amount" class="fw-bold">Entrer le montant:</label>
            </div>
          
            @if(fees>0){
              <div class="mb-3" >
                <label class="form-label" >Frais de service :<span class="fw-bold">{{fees}} {{student.currency?.currencyCode}}</span></label>
              </div>
            }
            @if(taxe>0){
              <div class="mb-3">
                <label  class="form-label" >Taxe :<span class="fw-bold">{{taxe}} {{student.currency?.currencyCode}}</span></label>
              </div>
            }
            @if(this.amouunt>0){
            <div class="payment-header">
              <h3></h3>
              <p class="text-center">Veuillez choisir votre moyen de paiement <br>Et Renseignez votre numéro de téléphone</p>
            </div>
            <div class="row justify-content-center gap-method">
              <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2 ml-3 p-2" style="width: auto;" data-method="card" (click)="onSelectPaymentMethod('card')">
                <img class="img-fluid" src="images/visamaster.png" alt="carte" width="50">
                <p class="mt-2 mb-0 text-center">Carte</p>
              </div>
              <div class="col-3 ml-2 payment-method border rounded d-flex flex-column justify-content-center mb-2" style="width: 135px;" data-method="omsn" (click)="onSelectPaymentMethod('omsn')">
                <img class="mt-4 img-fluid justify-content-center" src="images/omsn.webp" alt="orange money" width="50">
                <p class="mt-1 ml-3">Orange money</p>
              </div>
              <div class="col-3 payment-method border rounded d-flex flex-column justify-content-center mb-2" data-method="wvsn" style="width: auto;" (click)="onSelectPaymentMethod('wvsn')">
                <img class="mt-4 img-fluid justify-content-center" src="images/wave-logo.webp" alt="wave" width="50">
                <p class="mt-1  ml-3">Wave</p>
              </div>
            </div>
          }
              <div class="row justify-content-center">
                <div class="form-group form-floating">
                  @if (isWallet) {
                    <input type="tel" placeholder="Numero t&#233;l&#233;phone" class="form-control" formControlName="phone">
                    <label>Entrer votre numero de téléphone</label>
                  }
                </div>
              </div>
            }
            @if (isValid()&& !processing) {
              <div class="d-grid gap-2 col-6 mx-auto">
                <button class="btn btn-primary mt-3" (click)="processPayment()">
                Valider</button>
              </div>
            }
            </form>
          </div>
        
        </div>
      }
      @if(qrCode.length) {
        <div  class="row justify-content-center">
          <div class="d-flex justify-content-center" style="width: 300;">Scannez et payez </div>
          <div class="d-flex justify-content-center">
            @if(paymentNetwork.toLocaleLowerCase() == 'wvsn'){
             <div class="d-block">
              <img class="img-fluid" src="images/wave-logo.webp" alt="wave" width="120" height="50">
            </div>
            }
             @if(paymentNetwork.toLocaleLowerCase() == 'omsn'){
             <div class="d-block">
              <img class="img-fluid" src="images/omsn.webp" alt="orange money" width="120" height="50">
            </div>
            }
            
          </div>
          <div class="d-flex justify-content-center">
            <qrcode [qrdata]="qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
          </div>
          @if(!isDesktop){
          <div class="d-grid gap-2 col-6 mx-auto">
                <button class="btn btn-primary" (click)="openUrl(qrCode)">Ouvrir avec l'application</button>
              </div>
            }
        </div>
    }
    </div>
  </div>
</div>


